import './PrintSingleTenant.scss';
import Component from './PrintSingleTenant.js';
export default Component;
